import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce405414"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "s1" }, "Copyright © 2023 - 2024", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "s1" }, "四川省医疗卫生服务指导中心版权所有", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const jumpToLink = () => {
    window.open('https://beian.miit.gov.cn/#/Integrated/index');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("span", {
        class: "s1 hover",
        onClick: jumpToLink
      }, "备案号：蜀ICP备11024782号-1")
    ])
  ]))
}
}

})